'use client';

import { Trans } from '@lingui/macro';
import { Stack } from '@mui/material';
import { PoLoader } from '@prismo-io/design-system';
import { useCountdownDate } from '@prismo-io/utils/client/use-countdown-date';
import { useRouter } from 'next/navigation';
import { type FC, useEffect, useTransition } from 'react';

type Props = {
  endDate: Date;
};

export const Countdown: FC<Props> = (props) => {
  const { endDate } = props;

  const router = useRouter();
  const [isTransiting, setTransition] = useTransition();
  const { message, isEnded } = useCountdownDate(endDate);

  useEffect(() => {
    if (isEnded) {
      setTransition(() => {
        return router.refresh();
      });
    }
  }, [router, isEnded]);

  if (isTransiting) {
    return (
      <Stack component="span" gap={1} alignItems="center">
        <PoLoader scale={0.8} />
        <Trans>Récupération des résultats...</Trans>
      </Stack>
    );
  }

  return (
    <Stack component="span">
      <span>
        <Trans>Résultats débloqués automatiquement dans</Trans>
      </span>
      <span>{message.duration}</span>
    </Stack>
  );
};
